import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Loading, fmtTime } from "@/components/ui-kit";
import { ChevronRight } from "lucide-react";

export default function History() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/attempts").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;

  return (
    <div className="animate-fade-up">
      <PageHeader title="History" subtitle="Every assessment you've completed. Tap to reopen the full review." />
      {rows.length === 0 ? (
        <div className="ember-card py-16 text-center text-sm text-[#948EAB]">No completed assessments yet.</div>
      ) : (
        <div className="grid gap-3">
          {rows.map((a) => {
            const color = a.percentage >= 80 ? "#059669" : a.percentage >= 60 ? "#7C3AED" : "#E11D48";
            return (
              <Link key={a.id} to={`/student/result/${a.id}`} data-testid={`history-${a.id}`} className="ember-card ember-card-hover flex items-center gap-5 p-5">
                <div className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl" style={{ backgroundColor: `${color}18` }}>
                  <span className="font-heading text-lg font-extrabold" style={{ color }}>{a.percentage != null ? `${Math.round(a.percentage)}%` : <span className="text-xs text-[#7C3AED]">Pending</span>}</span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-heading font-bold text-[#1E1B2E]">{a.title || a.section_name}</div>
                  <div className="mt-0.5 flex flex-wrap gap-x-3 text-xs text-[#948EAB]">
                    {a.score != null && <span>{a.score}/{a.total} correct</span>}
                    <span>{fmtTime(a.time_taken_seconds)}</span>
                    <span>{a.program_name}</span>
                  </div>
                </div>
                <ChevronRight className="h-5 w-5 text-[#C4B5FD]" />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
